<template>

    <div class='container'>

        <edit-project-modal
            :project="project"
            :selectedTabIndex="editProjectModal.selectedTabIndex"
            :is-active="editProjectModal.isActive"
            @projectUpdated="projectUpdated">
        </edit-project-modal>

        <section class="hero">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">
                {{project.name}}
                <b-tooltip
                    label="This project is waiting to be approved by the university. It is not visible to other members yet."
                    type="is-warning"
                    position="is-right"
                    multilined>
                    <b-tag v-if="project.status === 'pending'" type="is-warning">Pending</b-tag>
                </b-tooltip>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                  <ul>
                    <li class="is-active"><a href="#" aria-current="page">University</a></li>
                    <li><router-link :to="project.university.routeLink">{{project.university.name}}</router-link></li>
                  </ul>
                </nav>
              </h1>
              <h2 class="subtitle">
                {{project.pitch}} <edit-link v-if="isOwnProject" @click="openProjectModal(0)"/>
              </h2>

              <div id='action-bar'> <!-- Actions -->
                  <div class='is-inline-block is-pulled-left'>
                      <div v-if="$root.isLoggedIn" class="tags has-addons">
                        <a v-if="!isProjectFavorited()" class="tag is-button is-info is-medium" @click="favoriteProject()">
                          <b-icon icon="star-outline"></b-icon>
                          <span>Favorite</span>
                        </a>
                        <a v-if="isProjectFavorited()" class="tag is-button is-info is-medium" @click="unfavoriteProject()">
                          <b-icon icon="star"></b-icon>
                          <span>Unfavorite</span>
                        </a>
                        <span id='follower-count' class="tag is-white is-medium">{{favoriteCount}}</span>
                      </div>
                  </div>

                  <div class='is-inline-block is-pulled-right'>
                    <a class="button" target='_blank' :href='shareUrls.facebook'>
                        <b-icon icon="facebook"></b-icon>
                        <span>Facebook</span>
                    </a>
                    <a class="button" target='_blank' :href='shareUrls.twitter'>
                        <b-icon icon="twitter"></b-icon>
                        <span>Twitter</span>
                    </a>
                    <!-- <a class="button" target='_blank' :href='shareUrls.google'>
                        <b-icon icon="google"></b-icon>
                        <span>Google+</span>
                    </a> -->
                    <a class="button" target='_blank' :href='shareUrls.linkedin'>
                        <b-icon icon="linkedin"></b-icon>
                        <span>LinkedIn</span>
                    </a>
                    <a class="button" target='_blank' :href='shareUrls.email'>
                        <b-icon icon="email-outline"></b-icon>
                        <span>Email</span>
                    </a>
                  </div>

                <p class='is-clearfix'></p>
              </div>

            </div>

          </div>
        </section>

        <div class='columns'>
            <div class='column is-9'>

                <div class='box'>

                    <div class='columns'>
                        <div class='column is-3'>
                            <figure class="image">
                                <img :src="project.image[0].sizes.card" width="256" height="256"/>
                            </figure>
                        </div>
                        <div class='column'>
                            <p>{{project.description}}</p>

                            <edit-link v-if="isOwnProject" @click="openProjectModal(0)" />
                        </div>
                    </div>

                </div>

                <div class='box' v-if="crowdfund.isActive">

                    <div class='is-pulled-right'>
                        <edit-link v-if="isOwnProject" icon="currency-usd" text="Manage" @click="goToProjectCrowdfundPage()" />
                    </div>

                    <h2 class='title is-4'>Crowdfunding</h2>

                    <p>{{crowdfund.message}}</p><br/>

                    <nav class="level">
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Current</p>
                          <p class="title">${{crowdfund.currentAmount}}</p>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Target</p>
                          <p class="title">${{crowdfund.targetAmount}}</p>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Backers</p>
                          <p class="title">{{crowdfund.totalBackers}}</p>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Ends in</p>
                          <p class="title"><b-icon icon="clock"></b-icon> {{parseInt(crowdfund.daysLeft)}} days</p>
                        </div>
                      </div>
                    </nav>

                    <progress class="progress is-success"
                        :value="crowdfund.currentAmount"
                        :max="crowdfund.targetAmount">
                        {{crowdfund.currentAmount}} of {{crowdfund.targetAmount}} raised
                    </progress>

                    <div class='has-text-centered'>
                        <b-button tag="router-link"
                            :to="'/donate/' + project.id"
                            type="is-large is-success">
                            Donate
                        </b-button>
                    </div>

                </div>

                <div class='box'>
                    <div class='is-pulled-right'>
                        <edit-link v-if="isOwnProject" icon="plus" text="Add" @click="openRoleModal()" />
                    </div>

                    <h2 class='title is-4'>Team</h2>

                    <role-modal :role="roleModal.role" :is-active="roleModal.isActive" :isOwnProject="roleModal.isOwnProject" :projectId="project.id" :selectedTabIndex="roleModal.selectedTabIndex"
                        @roleCreated="roleCreated"
                        @roleUpdated="roleUpdated"
                        @roleDeleted="roleDeleted"
                        @userApplied="userApplied"
                        @teammateAdded="teammateAdded"
                        @teammateRemoved="teammateRemoved"
                        @roleApplicationDeleted="roleApplicationDeleted"
                        @close="roleModalClosed">
                    </role-modal>

                    <!-- <div class='tile is-child' v-for="role in roles" :key="role.id">{{role.name}}</div> -->
                    <role-card v-for="role in roles" :key="role.id" :role="role" :showIfApplied="true"
                        @click="openRoleModal(role)">
                    </role-card>

                    <p class='is-clearfix'></p>
                </div>

                <div class='box' v-if="project.body">
                    <div class='is-pulled-right'>
                        <edit-link v-if="isOwnProject" @click="openProjectModal(2)" />
                    </div>
                    <span class='is-clearfix'></span>
                    <div class='content' v-html="project.body">

                    </div>
                </div>

            </div>

            <div class='column is-3'>
                <!-- Reserved -->
            </div>
        </div>
    </div>

</template>

<style scoped>
#action-bar { padding: 5px 0; border-bottom: 1px SOLID #DDD; }
#follower-count { border: 1px solid #999; border-left: none; }
</style>

<script>
export default {
  name: 'Project',
  data () {
    return {
        project: {
            name: '',
            pitch: '',
            description: '',
            image: 'https://placehold.it/400x400',
            body: '(Nondescript)',
            status: 'approved'
        },
        roles: [],
        roleModal: {
            role: null,
            isOwnProject: false,
            isActive: false
        },
        editProjectModal: {
            isActive: false,
            menu: 'general', // general, body, team
        },
        crowdfund: {},
        isOwnProject: false, // if the logged-in user owns this project
        favoriteCount: 0 // this is cached from project, so when the user stars or unstars, the number increments or decrements
    }
  },
  methods: {
    goToProjectCrowdfundPage: function() {
        this.$router.push({ path: '/project/' + this.project.id + '/crowdfund' });
    },
    openProjectModal: function(tabIndex) {
        this.editProjectModal.selectedTabIndex = tabIndex;
        this.editProjectModal.isActive = true;
    },
    projectUpdated: function(updatedProject) {
        this.project = { ...this.project, ...updatedProject };
        this.editProjectModal.isActive = false;
    },
    openRoleModal: function(role) {
        this.roleModal = {
            role: role || { name: '', body: '', projectId: this.project.id },
            selectedTabIndex: 0,
            isOwnProject: this.isOwnProject,
            isActive: true
        };
    },
    findRoleIndexById(roleId) {
        return this.roles.findIndex((role) => {
            return role.id === roleId;
        });
    },
    roleCreated(role) {
        this.roles.push(role);
    },
    roleUpdated(role) {
        var roleIndex = this.findRoleIndexById(role.id);
        this.roles[roleIndex] = { ...this.roles[roleIndex], role }; // apply changes to role; do not assign directly since applications would be overridden
    },
    roleDeleted(role) {
        var roleIndex = this.findRoleIndexById(role.id);
        this.$delete(this.roles, roleIndex);
    },
    userApplied(data) {
        var roleIndex = this.findRoleIndexById(data.role.id);
        this.roles[roleIndex].applications.push(data.application);
    },
    roleApplicationDeleted(application) {
        var roleIndex = this.findRoleIndexById(application.role);
        var applicationIndex = this.roles[roleIndex].applications.findIndex((app) => {
            return app.id === application.id;
        });
        this.$delete(this.roles[roleIndex].applications, applicationIndex);

        // If the current user has an application, delete it
        var selfApplicationIndex = this.$root.applications.findIndex((app) => {
            return app.role === application.role;
        });
        if(selfApplicationIndex !== -1) this.$delete(this.$root.applications, selfApplicationIndex);
    },
    teammateAdded(data) { // data contains `user`, `roleId`
        var roleIndex = this.findRoleIndexById(data.roleId);
        this.$set(this.roles[roleIndex], 'user', data.user); //this.roles[roleIndex].user = data.user;
        this.$set(this.roles[roleIndex], 'applications', []);

        // If the teammate added was "myself", delete "my" application
        var myApplicationIndex = this.$root.applications.findIndex((application) => {
            return application.role === data.roleId;
        });
        if(myApplicationIndex !== -1) this.$delete(this.$root.applications, myApplicationIndex);
    },
    teammateRemoved(role) {
        var roleIndex = this.findRoleIndexById(role.id);
        this.$delete(this.roles[roleIndex], 'user');
    },
    roleModalClosed() {
        this.roleModal.isActive = false;
        this.roleModal.role = { name: '', body: '', projectId: this.project.id };
    },
    isProjectFavorited: function() {
        return this.$root.favorites.indexOf(this.project.id) >= 0;
    },
    favoriteProject: function() {
        this.$http.put(this.URL.favorite).then(function(response) {
            this.$root.favorites.push(this.project.id); // save to session cache
            this.favoriteCount++;
        });
    },
    unfavoriteProject: function() {
        this.$http.delete(this.URL.favorite).then(function(response) {
            this.$root.favorites.splice(this.$root.favorites.indexOf(this.project.id), 1); // remove from session cache
            this.favoriteCount--;
        });
    }
  },
  computed: {
    shareUrls: function() {
        // See: https://github.com/bradvin/social-share-urls
        var projectUrl = 'https://biaggeo.com/project/' + this.project.id + '/' + this.$root.dashify(this.project.name),
            text = encodeURI('Check out ' + this.project.name + ' on Biaggeo, the platform for student entrepreneurs!');

        return {
            facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + projectUrl,
            twitter: 'https://twitter.com/intent/tweet?url=' + projectUrl + '&text=' + text + '&hashtags=biaggeo,entrepreneur,project,student,university',
            google: 'https://plus.google.com/share?url=' + projectUrl + '&text=' + text,
            linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=' + projectUrl,
            email: 'mailto:<recipient@email.com>?subject=' + encodeURI(this.project.name) + ' on Biaggeo!&body=' + projectUrl
        };
    },
    URL() {
        return {
            projectAndId: this.$hostname + '/project/' + this.$route.params.projectId,
            favorite: this.$hostname + '/project/' + this.project.id + '/favorite',
        }
    }
  },
  // beforeRouteEnter: function(to, from, next) {
  //     // e.g. /project/1 or /project/1/puppy-finder-app
  //     var trimmedPath = to.fullPath.replace(/project\/[0-9]*/gi, '');
  //     console.log(trimmedPath, trimmedPath[0], trimmedPath[0] === '/');
  //     if(trimmedPath[0] === '/') trimmedPath = trimmedPath.substr(1);
  //     console.log(trimmedPath);
  //     if(trimmedPath.length === 0) {
  //       console.log('path is missing name');
  //     }
  //     next();
  // },
  mounted: function() {

    this.$http.get(this.URL.projectAndId).then(function(response) {
        this.project = response.body;
        this.project.university.routeLink = '/u/' + this.project.university.slug;
        this.favoriteCount = this.project.favoriters.length;
    });

    this.$http.get(this.$hostname + '/crowdfund/' + this.$route.params.projectId).then(function(response) {
        this.crowdfund = response.body;
    });

    this.$http.get(this.URL.projectAndId + '/roles').then(function(response) {
        var that = this;

        response.body.forEach(function(role) {
            if(role.user && role.user.id == that.$root.user.id && role.isOwner) {
                that.isOwnProject = true;
            }
        });

        this.roles = response.body;
    });

  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Project.vue